export enum AmpEventSourceTypeEssentials {
    ESSENTIALS = 'essentials'
}
